import { Component, Inject, OnInit, forwardRef } from '@angular/core';

import { UserflowService } from './userflow.service';

@Component({
  selector: 'wor-userflow-initializer',
  template: ''
})
export class UserflowInitializerComponent implements OnInit {
  constructor (
    @Inject(forwardRef(() => UserflowService)) private userflowService: UserflowService
  ) {}

  ngOnInit () : void {
    this.userflowService.initialize();
  }
}
